import React, { useEffect, useState } from 'react';
import Plot from 'react-plotly.js';
import axiosInstance from '../utils/axiosInstance';
import { plotlyStyle } from '../utils/plotlyStyle';
import { Typography } from '@mui/material';
import { MESSAGES } from '../constants/messages';

const ChartOrderStatus = () => {
  const [statusData, setStatusData] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const res = await axiosInstance.get(
          '/chart/order-status-count'
        );

        setStatusData(res.data);
        setError(null);
      } catch (err) {
        setError('データの取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchStatusData();
  }, []);

  if (loading) {
    return (
      <Typography>
        {MESSAGES.LOADING}
      </Typography>
    );
  }

  if (error) {
    return (
      <Typography>
        {error || MESSAGES.LOAD_FAILED}
      </Typography>
    );
  }

  const statusPlotData = {
    labels: statusData.map(
      item => item.order_status_name
    ),

    values: statusData.map(item =>
      Number(item.count)
    ),

    type: 'pie',

    marker: {
      colors: plotlyStyle.colors.pie,
    },

    textinfo: 'label+percent',
    textposition: 'inside',
    hovertemplate:
      '%{label}<br>' +
      '注文数: %{value:,.0f}件<br>' +
      '割合: %{percent}' +
      '<extra></extra>',

    sort: false,
  };

  const statusLayout = {
    ...plotlyStyle.layout,

    title: {
      text: '現在の注文状況',
    },

    showlegend: true,

    legend: {
      orientation: 'h',
      y: -0.15,
    },

    margin: {
      t: 80,
      b: 80,
      l: 40,
      r: 40,
    },
  };

  return (
    <Plot
      data={[statusPlotData]}
      layout={statusLayout}
      style={{
        width: '100%',
        height: '100%',
        minHeight: 500,
      }}
      useResizeHandler
      config={{
        responsive: true,
        displayModeBar: false,
      }}
    />
  );
};

export default ChartOrderStatus;